const AppConfigs = {
  gaKey: process.env.REACT_APP_GA_KEY,
  apiVersion: process.env.REACT_APP_API_VERSION,
  startDate: process.env.REACT_APP_START_DATE_CAMPAIGN,
  endDate: process.env.REACT_APP_END_DATE_CAMPAIGN,
  subscriptionKeyCampaign: process.env.REACT_APP_SUB_KEY,
  envUtopSDK: process.env.REACT_APP_UTOP_SDK_VERSION,
  trackingKey: process.env.REACT_APP_TRACKING_KEY,
  privacyLink: process.env.REACT_APP_PRIVACY_LINK,
  cookieLink: process.env.REACT_APP_COOKIE_LINK,
  toothlensUrl: process.env.REACT_APP_TOOTHLENS_URL
};

export default AppConfigs;
